const actions = {
  GET_MENU_ITEMS_REQUEST: "GET_MENU_ITEMS_REQUEST",
  GET_MENU_ITEMS_SUCCESS: "GET_MENU_ITEMS_SUCCESS",

  GET_CATEGORIES_REQUEST: "GET_CATEGORIES_REQUEST",
  GET_CATEGORIES_SUCCESS: "GET_CATEGORIES_SUCCESS",

  EDIT_MENU_ITEMS_REQUEST: "EDIT_MENU_ITEMS_REQUEST",
  EDIT_MENU_ITEMS_SUCCESS: "EDIT_MENU_ITEMS_SUCCESS",

  EDIT_CATEGORY_REQUEST: "EDIT_CATEGORY_REQUEST",
  EDIT_CATEGORY_SUCCESS: "EDIT_CATEGORY_SUCCESS",

  RELOAD_CATEGORIES_STATE: "RELOAD_CATEGORIES_STATE",
  RELOAD_MENU_ITEMS_STATE: "RELOAD_MENU_ITEMS_STATE",
  RELOAD_ITEMS_TAGS_STATE: "RELOAD_ITEMS_TAGS_STATE",

  SYNC_MENU_CONFIGURATION_IMAGES_REQUEST:
    "SYNC_MENU_CONFIGURATION_IMAGES_REQUEST",
  SYNC_MENU_CONFIGURATION_IMAGES_SUCCESS:
    "SYNC_MENU_CONFIGURATION_IMAGES_SUCCESS",
  LOADING_SYNC_IMAGES_REQUEST: "LOADING_SYNC_IMAGES_REQUEST",

  GET_MENU_ITEM_IMAGE_REQUEST: "GET_MENU_ITEM_IMAGE_REQUEST",
  GET_MENU_ITEM_IMAGE_SUCCESS: "GET_MENU_ITEM_IMAGE_SUCCESS",

  GET_ITEMS_TAGS_REQUEST: "GET_ITEMS_TAGS_REQUEST",
  GET_ITEMS_TAGS_SUCCESS: "GET_ITEMS_TAGS_SUCCESS",

  EDIT_TAG_REQUEST: "EDIT_TAG_REQUEST",
  EDIT_TAG_SUCCESS: "EDIT_TAG_SUCCESS",

  UPDATE_MENU_ITEMS_IMAGES_REQUEST: "UPDATE_MENU_ITEMS_IMAGES_REQUEST",
  UPDATE_MENU_ITEMS_IMAGES_SUCCESS: "UPDATE_MENU_ITEMS_IMAGES_SUCCESS",

  getAllMenuItems: (
    organizationId,
    restaurantId,
    defaultOrganizatoinLanguage
  ) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_MENU_ITEMS_REQUEST,
        organizationId,
        restaurantId,
        defaultOrganizatoinLanguage,
      });
    };
  },

  getAllCategories: (organizationId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_CATEGORIES_REQUEST,
        organizationId,
      });
    };
  },

  editMenuItem: (menuItem) => {
    return (dispatch) => {
      dispatch({
        type: actions.EDIT_MENU_ITEMS_REQUEST,
        menuItem,
      });
    };
  },

  editCategory: (category) => {
    return (dispatch) => {
      dispatch({
        type: actions.EDIT_CATEGORY_REQUEST,
        category,
      });
    };
  },

  syncMenuConfigurationImages: (organizationId) => {
    return (dispatch) => {
      dispatch({
        type: actions.SYNC_MENU_CONFIGURATION_IMAGES_REQUEST,
        organizationId,
      });
    };
  },
  loadingSyncImages: () => {
    return (dispatch) => {
      dispatch({
        type: actions.LOADING_SYNC_IMAGES_REQUEST,
      });
    };
  },

  getMenuItemImage: (organizationId, itemId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_MENU_ITEM_IMAGE_REQUEST,
        organizationId,
        itemId,
      });
    };
  },

  getAllItemsTags: (organizationId) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_ITEMS_TAGS_REQUEST,
        organizationId,
      });
    };
  },

  editTag: (tag) => {
    return (dispatch) => {
      dispatch({
        type: actions.EDIT_TAG_REQUEST,
        tag,
      });
    };
  },

  updateMenuItemImages: (imagesState) => {
    return (dispatch) => {
      dispatch({
        type: actions.UPDATE_MENU_ITEMS_IMAGES_REQUEST,
        imagesState,
      });
    };
  },
};

export default actions;
